// PCG-32-RXS-M-XS-32
// https://github.com/imneme/pcg-c/blob/master/include/pcg_variants.h
// https://www.pcg-random.org/pdf/hmc-cs-2014-0905.pdf

const MULTIPLIER = 747796405;
const INCREMENT = 2891336453;

export class Pcg {
	// @ts-ignore - initialized by seed()
	state: number;

	constructor(init_state: number) {
		this.seed(init_state);
	}

	step () {
		this.state = (Math.imul(this.state, MULTIPLIER) + INCREMENT) >>> 0;
	}

	seed (init_state: number) {
		this.state = 0;
		this.step();
		this.state = (this.state + init_state) >>> 0;
		this.step();
	}

	next () {
		const { state } = this;
		this.step();
		const word = Math.imul((((state >>> ((state >>> 28) + 4)) ^ state) >>> 0), 277803737);
		return ((word >>> 22) ^ word) >>> 0;
	}
}

export const rng = new Pcg(new Date().getTime());

export { Pcg as default };
